











 














const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageTeamMember_teamMember",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamMemberAvatarMenu_teamMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LeaveTeamModal_teamMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PromoteTeamMemberModal_teamMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoveTeamMemberModal_teamMember"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLead",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrgAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};

(node ).hash = "23ce69c0c3b8b72e7cce73ddeded1d45";

export default node;
